/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PdpHead_viewer$ref = any;
export type PdpHead_viewer = {
    readonly isPdpUrlTranslationEnabled: boolean | null;
    readonly " $refType": PdpHead_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpHead_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": "isPdpUrlTranslationEnabled",
            "name": "isEnabled",
            "args": [
                {
                    "kind": "Literal",
                    "name": "key",
                    "value": "translatedPdpUrls"
                }
            ],
            "storageKey": "isEnabled(key:\"translatedPdpUrls\")"
        }
    ]
} as any);
(node as any).hash = 'ef125614954ce0c1dfcbe52ac1e72cf2';
export default node;
